import React from "react";
import moment from "moment";
import { TAnnex6V2Record } from "redux/app/annex6-v2/@types";
import { TAnnex6V2GroupE2 } from "redux/app/annex6-v2/groups/group-e";
import Annex6V2TableRows from "../Annex6V2TableRows";

type OwnProps = {
	annex6V2Record: TAnnex6V2Record;
	isStrikedOff?: boolean;
	theme?: "light" | "dark";
};
type Annex6V2GroupE2PreviewProps = OwnProps;

function Annex6V2GroupE2Preview(props: Annex6V2GroupE2PreviewProps) {
	const record = props.annex6V2Record as TAnnex6V2GroupE2;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);

	function renderMain() {
		const tableRows = [
			[operationDate, "E", "2.1", renderItem1()],
			[null, null, "2.2", renderItem2()],
		];

		if (record.remarks) {
			tableRows.push([null, null, "NOTE", record.remarks]);
		}

		return (
			<Annex6V2TableRows
				record={record}
				tableRows={tableRows}
				theme={props.theme}
			/>
		);
	}

	function renderItem1() {
		return (
			<h4 className="font-medium uppercase">
				CHANGE OF SETTINGS ON ECGS UPON EXIT INTO SECA
			</h4>
		);
	}

	function renderItem2() {
		const { date: smtDate, time: smtTime } = record.itemE2;
		const dateTimeLocal = `${smtDate}T${smtTime}:00${record.timeZone}`;
		const utcTime = moment.utc(dateTimeLocal);

		return (
			<h4 className="font-medium uppercase">
				{utcTime.format("HH:mm")} hrs UTC on {utcTime.format("DD-MMM-YYYY")} (
				{smtTime} SMT on {moment(smtDate, "YYYY-MM-DD").format("DD-MMM-YYYY")})
				at {record.itemE2.latitude} | {record.itemE2.longitude}
			</h4>
		);
	}

	return renderMain();
}

export default Annex6V2GroupE2Preview;
